import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled } from "@mui/material";
import { useEffect, useState } from "react";
import "./index.css"
import { DefaultArrayEmpty, I18n, ParseHtml } from "utilities/utilities";
import UploadFileItem from "components/Input/UploadFile";
import { useForm, FormProvider } from "react-hook-form";

export default function TableActivityGanttChart(props) {

    const { data } = props;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dataTable, setDataTable] = useState([]);
    const [selected, setSelected] = useState<readonly number[]>([]);

    const formFile = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    useEffect(() => {
        setDataTable([...data]);
    }, [data])

    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event?.target?.checked) {
            const newSelected = dataTable.map((n) => n.nID);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover,
        }
    }));

    return (
        <>
            <TableContainer id='table-report' component={Paper}>
                <Table sx={{ minWidth: 500 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }} rowSpan={3}>ลำดับ</TableCell>
                            <TableCell align="center" style={{ minWidth: '350px', width: '50%' }} rowSpan={3}>กิจกรรม</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '30%' }} rowSpan={3}>ค่าน้ำหนัก</TableCell>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }} colSpan={12}>ระยะเวลาการดำเนินงาน</TableCell>
                            <TableCell align="center" style={{ minWidth: '200px', width: '20%' }} rowSpan={3}>การประชุมคณะกรรมการ/<br />คณะอนุกรรมการที่เกี่ยวข้อง</TableCell>
                            <TableCell align="center" style={{ minWidth: '300px', width: '20%' }} rowSpan={3}>ชื่อผู้รับผิดชอบกิจกรรม</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }} colSpan={3}>ไตรมาส 1</TableCell>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }} colSpan={3}>ไตรมาส 2</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '50%' }} colSpan={3}>ไตรมาส 3</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '30%' }} colSpan={3}>ไตรมาส 4</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }}>ม.ค.</TableCell>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }}>ก.พ.</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '50%' }}>มี.ค.</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '30%' }}>เม.ย.</TableCell>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }}>พ.ค.</TableCell>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }}>มิ.ย.</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '50%' }}>ก.ค.</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '30%' }}>ส.ค.</TableCell>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }}>ก.ย.</TableCell>
                            <TableCell align="center" style={{ minWidth: '100px', width: '10%' }}>ต.ค.</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '50%' }}>พ.ย.</TableCell>
                            <TableCell align="center" style={{ minWidth: '120px', width: '30%' }}>ธ.ค.</TableCell>
                        </TableRow>

                    </TableHead>
                    {
                        dataTable.length > 0 ?
                            <TableBody>
                                {DefaultArrayEmpty(dataTable).map((activity, index) => {
                                    const lstAssign = DefaultArrayEmpty(activity.lstAssign).map(m => m.sName);
                                    const lstGroupMeeting = [].concat(...DefaultArrayEmpty(activity.lstMeeting).map(m => m.lstChildren)).map(m => m.sName);
                                    return (
                                        <StyledTableRow key={"activity_table" + activity.nID} style={{ background: index % 2 === 0 ? "rgb(243 243 243)" : "#fff" }}>
                                            <TableCell align="left">
                                                {activity.sOrder}
                                            </TableCell>
                                            <TableCell align="left">
                                                {activity.sActivityName}
                                            </TableCell>
                                            <TableCell align="center">
                                                {activity.sWeight}
                                            </TableCell>
                                            {/* duration */}
                                            {DefaultArrayEmpty(activity.lstMonth).map((duration, i) => {
                                                return (
                                                    <TableCell align="center" key={"duration_" + (duration[i] ?? i)} style={{ background: duration.IsChecked ? "#6596f5" : "" }}></TableCell>
                                                )
                                            })}
                                            <TableCell align="left">
                                                {ParseHtml(lstGroupMeeting.join("<br/>"))}
                                            </TableCell>
                                            <TableCell align="left">
                                                {ParseHtml(lstAssign.join("<br/>"))}
                                            </TableCell>
                                        </StyledTableRow>
                                    )
                                })}
                            </TableBody>
                            :
                            <TableRow key={"r-no-data"} >
                                <TableCell align="center" colSpan={20}>ไม่พบข้อมูล</TableCell>
                            </TableRow>
                    }
                </Table>
            </TableContainer>
            {/* <CustomTablePagination
                dataTable={dataTable}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                page={page}
                setPage={setPage}
                colSpan={4}
                selection={selected}
                onDelete={onDelete}
                handleSelectAllClick={handleSelectAllClick}
            /> */}
        </>
    )
}